import posthog from 'posthog-js'

// PostHog product analytics for the garage-staff dashboard.
//
// Key is inlined from VITE_POSTHOG_KEY at build time. When unset, initAnalytics
// is a no-op and every helper below does nothing — local dev stays silent unless
// a key is provided. distinct_id is the backend User#id (set on login) so these
// events stitch to the authoritative server-side events; B2B events are grouped
// by the acting garage/car-care center. Read via a local cast (see sentry.ts).
const env =
  (import.meta as unknown as { env?: Record<string, string | undefined> }).env ?? {}
const key = env.VITE_POSTHOG_KEY

let started = false

export function initAnalytics() {
  if (!key || started) return
  started = true
  posthog.init(key, {
    api_host: env.VITE_POSTHOG_HOST ?? 'https://eu.i.posthog.com',
    // Only create person profiles for identified (logged-in staff) users.
    person_profiles: 'identified_only',
    capture_pageview: true,
  })
  posthog.register({ platform: 'web_dashboard' })
}

type StaffUser = { id: number | string; email?: string | null; name?: string | null }
type Membership = { type: 'garage' | 'car_care'; id: number | string }

export function identifyStaff(user: StaffUser, membership?: Membership | null) {
  if (!key) return
  posthog.identify(String(user.id), {
    email: user.email,
    name: user.name,
    membership_type: membership?.type,
  })
  groupBusiness(membership)
}

// Associate subsequent events with the acting garage/car-care center.
export function groupBusiness(membership?: Membership | null) {
  if (!key || !membership) return
  posthog.group(membership.type, String(membership.id))
}

export function trackWeb(event: string, properties?: Record<string, any>) {
  if (!key) return
  posthog.capture(event, properties)
}

export function setAnalyticsTenant(tenant: string) {
  if (!key) return
  posthog.register({ tenant })
}

export function resetAnalytics() {
  if (!key) return
  posthog.reset()
}
